import { useAuthContext } from "../../auth/state/AuthContext";
import { Certificate, CertificateDto } from "../../certificates/models/certificates.interfaces";
import Header from "../../shared/app-shell/HeaderTechform";
import Sidebar from "../../shared/app-shell/Sidebar";
import { themeAtom } from "../../shared/atoms";
import HeaderTitle from "../../shared/components/HeaderTitle";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import { getRequestedDocuments } from "../services/documents.service";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const MissingDocumentsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { sub: email } = useAuthContext().state.user?.accessToken || {};
  const [isLoading, setIsLoading] = useState(false);
  const [requestedDocs, setRequestedDocs] = useState<Certificate[]>([]);
  const theme = useAtomValue(themeAtom);
  const missingDocs = (requestedDocs as any as CertificateDto[]).map((doc) => doc.DOC_NAME); // TOOD change the code to fit changes from Molina
  const vesselName = searchParams.get("vessel");

  useEffect(() => {
    const fetchRequestedDocuments = async () => {
      try {
        setIsLoading(true);
        const requestedDocuments = await getRequestedDocuments();
        setRequestedDocs(requestedDocuments);
        setIsLoading(false);
      } catch (error: unknown) {
        setIsLoading(false);
      }
    };

    fetchRequestedDocuments();
    sessionStorage.clear();
  }, [email]);

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName={theme.home.tailwind.spinner} loadingIndicatorSize="lg">
      <div className="flex h-screen">
        <Sidebar />
        <div
          className={twMerge(
            "flex flex-1 flex-col overflow-y-hidden",
            theme.home.tailwind.pageBackground,
            theme.home.tailwind.textDefault,
          )}
        >
          <Header />

          <div className="flex h-screen flex-col">
            <div className="mb-6 mt-4 px-6">
              <HeaderTitle title={"Missing documents"} />
            </div>

            <div className={twMerge("flex w-[79ch] flex-col px-6 text-sm", theme.uwhcAssistant.textOutput)}>
              <p>
                We would like to request assistance in locating some missing documents related to the {vesselName}{" "}
                vessel.
              </p>

              <p className="mt-4">Please send the following documents:</p>

              {missingDocs && (
                <ol className="ml-5 list-decimal">
                  {missingDocs.map((missingDoc: string) => (
                    <li>{missingDoc}</li>
                  ))}
                </ol>
              )}

              <p className="mt-4">We would appreciate it if you could provide these at your earliest convenience.</p>

              <div className="mt-6">
                <button
                  onClick={() => navigate("/landingPage")}
                  className={twMerge(
                    "ml-auto mr-[24px] rounded border px-4 py-2 text-sm",
                    theme.uwhcAssistant.sendBorder,
                    theme.uwhcAssistant.chatBg,
                    theme.headerComponent.tailwind.buttonText,
                    theme.headerComponent.tailwind.buttonHoverBg,
                    theme.headerComponent.tailwind.buttonHoverText,
                  )}
                >
                  Cancel
                </button>

                <a
                  href="mailto:ops_support@cargill.com?subject=Documents requested&body=Attaching the missing documents below"
                  target="_blank"
                  rel="noreferrer"
                  className={twMerge("mr-[40px] inline-block rounded px-4 py-2 text-sm text-white", theme.home.tailwind.greenBg)}
                  onClick={() => {
                    navigate("/landingPage");
                  }}
                >
                  Send documents
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingWrapper>
  );
};

export default MissingDocumentsPage;
